import { get, post } from '../../Http/index'
import { financeBasicLv, financeInvoicecenter ,financeImagecenter} from "../../config";
//查询是否领取资格
function canBuyOrNot(params) {
    return post(`/${financeInvoicecenter}/invoiceBuyRecord/canBuyOrNot`, params)
}
//查询税收分类树状
function TaxList(params) {
    return get("/api-finbasic/basictaxclass/queryAbbTree", params)
}
//查询税收分类树状
function TaxAllList(params) {
    return get("/api-finbasic/basictaxclass/queryTree", params)
}
function queryAllByOrgId(params) {
    return post(`/${financeBasicLv}/basicaccountbook/queryAllByOrgId`, params)
}
//领取发票
function buyInvoice(params) {
    return post(`/${financeInvoicecenter}/invoiceBuyRecord/buyInvoice`, params)
}
//查询剩余领购详情
function buyInvoiceQuery(params) {
    return post(`/${financeInvoicecenter}/invoiceBuyRecord/buyInvoiceQuery`, params)
}
//帐套id查询详情
function findByAbId(params) {
    return post(`/${financeInvoicecenter}/oiBasicAccountBook/findByAbId`, params)
}
//发票保存
function billopenSave(params) {
    return post(`/${financeInvoicecenter}/billopen/save`, params)
}
//发票列表
function billopenFindList(params) {
    return post(`/${financeInvoicecenter}/billopen/findList?currentPage=${params.currentPage}&pageSize=${params.pageSize}`, params)
}
//开票网点详情
function getBillPortInfo(params) {
    return post(`/${financeInvoicecenter}/getBillPortInfo`, params)
}
//校验税控盘密码
function validateTaxDiskPassword(params) {
    return get(`/${financeInvoicecenter}/vtbillport/validateTaxDiskPassword?terminalId=${params.id}&taxDiskPwd=${params.password}`)
}
//获取可作废发票号
function fetchCurrInvoiceCodeAndNo(params) {
    return post(`/${financeInvoicecenter}/billopen/fetchCurrInvoiceCodeAndNo`, params)
}
//作废空白发票
function blankInvoiceInvalid(params) {
    return post(`/${financeInvoicecenter}/billopen/blankInvoiceInvalid`, params)
}
//根据id获取发票详情
function selectByPrimaryKey(id) {
    return post(`/${financeInvoicecenter}/billopen/selectByPrimaryKey?id=${id}`)
}
//蓝票开具
function billBlueOpen(params, ids) {
    return post(`/${financeInvoicecenter}/billopen/open?date=${params.date}&saleId=111`, ids)
}
//红票开具
function billBlueOpenRed(params, ids) {
    return post(`/${financeInvoicecenter}/billopen/openRed?msgcode=${params.msgcode}&fdate=${params.date}&creater=${params.creater}`, ids)
}
//删除
function deleteAll(params) {
    return post(`/${financeInvoicecenter}/billopen/deleteAll`, params)
}
//作废已开发票
function Invalid(params) {
    return post(`/${financeInvoicecenter}/billopen/invalid`, params)
}
//下载
function fileDownload(params) {
    return post(`/${financeImagecenter}/file/download?abId=${params.abId}&fileIds=${params.fileId}`, {}, { responseType: 'blob' })
}
//导出
function exportGoods(id) {
    return get(`/${financeInvoicecenter}/billopenb/exportGoods?id=${id}`, {}, { responseType: 'blob' })
}
//专票开红票获取详情
function returnRed(id) {
    return post(`/${financeInvoicecenter}/billopen/returnRed`,id)
}
//专票红票申请
function record(params) {
    return post(`/${financeInvoicecenter}/redInvoiceApplyRecord/record`,params)
}
export default {
    canBuyOrNot,
    TaxList,
    TaxAllList,
    queryAllByOrgId,
    buyInvoice,
    buyInvoiceQuery,
    findByAbId,
    billopenSave,
    billopenFindList,
    getBillPortInfo,
    validateTaxDiskPassword,
    fetchCurrInvoiceCodeAndNo,
    blankInvoiceInvalid,
    selectByPrimaryKey,
    billBlueOpen,
    billBlueOpenRed,
    deleteAll,
    Invalid,
    fileDownload,
    exportGoods,
    returnRed,
    record
}


// WEBPACK FOOTER //
// ./src/api/billManagementApi/cloud-invoicing/index.js